export default __webpack_public_path__ + "static/media/malt_green.da678ccc.svg";